












import moment from "moment"
moment.locale("fr")

export default {
    "name": "StateNew"
    "props": {
        "context": {
            "type": Object
            "required": true
        }
    }
    "computed":
        "human_published_on": ()->
            return moment(@context.data.published_on).fromNow()
        "human_created_on": ()->
            result = moment(@context.created_on).fromNow()
            return result
}   
